import React, { useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../ServicePage.css';

function ConsulenzaTecnica() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="service-page">
            <Container>
                <div className="service-header">
                    <h1 className="service-title gradient-text">Consulenza Tecnica</h1>
                    <p className="service-description">
                        Analisi e ottimizzazione di progetti esistenti, architettura software,
                        supporto nella scelta delle soluzioni IT e coordinamento con i fornitori.
                    </p>
                </div>

                <Row className="mb-5">
                    <Col lg={12}>
                        <Card className="service-card">
                            <Card.Body>
                                <h2 className="section-title">Cos'è la Consulenza Tecnica?</h2>
                                <p className="section-description">
                                    La consulenza tecnica è un servizio specializzato che aiuta le aziende a ottimizzare
                                    i loro progetti software esistenti, migliorare l'architettura e identificare
                                    soluzioni per problemi di performance, sicurezza e scalabilità. E non si ferma
                                    al presente: ti aiutiamo a pianificare i miglioramenti futuri e a valutare
                                    per tempo le nuove tecnologie, prima che diventino una necessità.
                                </p>
                                
                                <div className="consulting-features">
                                    <Row>
                                        <Col md={6}>
                                            <div className="feature-item">
                                                <i className="fas fa-search text-primary"></i>
                                                <strong>Analisi Approfondita</strong>
                                                <p>Verifica dei workflow interni dell'azienda, dei processi e degli strumenti in uso</p>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="feature-item">
                                                <i className="fas fa-lightbulb text-primary"></i>
                                                <strong>Soluzioni Strategiche</strong>
                                                <p>Roadmap e raccomandazioni per miglioramenti a lungo termine</p>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="feature-item">
                                                <i className="fas fa-tachometer-alt text-primary"></i>
                                                <strong>Ottimizzazione Performance</strong>
                                                <p>Identificazione e risoluzione di bottleneck prestazionali</p>
                                            </div>
                                        </Col>
                                        <Col md={6}>
                                            <div className="feature-item">
                                                <i className="fas fa-shield-alt text-primary"></i>
                                                <strong>Security Assessment</strong>
                                                <p>Valutazione e miglioramento della sicurezza applicativa</p>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row className="mb-5">
                    <Col lg={12}>
                        <Card className="service-card highlight-card">
                            <Card.Body>
                                <h2 className="section-title">I Nostri Servizi di Consulenza</h2>
                                
                                <Row>
                                    <Col lg={6} className="mb-4">
                                        <div className="service-item">
                                            <div className="service-icon">
                                                <i className="fas fa-sitemap text-primary"></i>
                                            </div>
                                            <h4>Architettura Software</h4>
                                            <p>
                                                Progettazione e revisione di architetture software per migliorare
                                                scalabilità, manutenibilità e performance.
                                            </p>
                                        </div>
                                    </Col>
                                    
                                    <Col lg={6} className="mb-4">
                                        <div className="service-item">
                                            <div className="service-icon">
                                                <i className="fas fa-chart-line text-primary"></i>
                                            </div>
                                            <h4>Ottimizzazione Performance</h4>
                                            <p>
                                                Identificazione di bottleneck e implementazione di soluzioni
                                                per migliorare le performance delle applicazioni.
                                            </p>
                                        </div>
                                    </Col>
                                    
                                    <Col lg={6} className="mb-4">
                                        <div className="service-item">
                                            <div className="service-icon">
                                                <i className="fas fa-chalkboard-user text-primary"></i>
                                            </div>
                                            <h4>Formazione su Misura</h4>
                                            <p>
                                                Percorsi di formazione costruiti sulle persone della tua azienda:
                                                affianchiamo passo dopo passo anche chi ha poca dimestichezza
                                                con la tecnologia, con tempi e modalità calibrati su ciascuno.
                                            </p>
                                        </div>
                                    </Col>

                                    <Col lg={6} className="mb-4">
                                        <div className="service-item">
                                            <div className="service-icon">
                                                <i className="fas fa-compass text-primary"></i>
                                            </div>
                                            <h4>Scelta delle Soluzioni IT</h4>
                                            <p>
                                                Ti aiutiamo a valutare e scegliere software, piattaforme e tecnologie
                                                davvero adatte alla tua azienda, evitando investimenti sbagliati
                                                e soluzioni sovradimensionate.
                                            </p>
                                        </div>
                                    </Col>

                                    <Col lg={6} className="mb-4">
                                        <div className="service-item">
                                            <div className="service-icon">
                                                <i className="fas fa-handshake text-primary"></i>
                                            </div>
                                            <h4>Coordinamento con i Fornitori</h4>
                                            <p>
                                                Gestiamo al posto tuo i progetti realizzati dai fornitori IT:
                                                valutiamo preventivi, contratti e SLA, coordiniamo le attività
                                                e verifichiamo che i risultati rispettino gli accordi.
                                                Tu hai un unico interlocutore tecnico: noi.
                                            </p>
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row className="mb-5">
                    <Col lg={12}>
                        <Card className="service-card">
                            <Card.Body>
                                <h2 className="section-title">Perché Scegliere la Nostra Consulenza?</h2>
                                
                                <Row>
                                    <Col md={4} className="text-center mb-4">
                                        <div className="advantage-item">
                                            <div className="advantage-icon">
                                                <i className="fas fa-medal text-primary"></i>
                                            </div>
                                            <h5>Esperienza Pluriennale</h5>
                                            <p>Anni di esperienza su progetti complessi in diversi settori</p>
                                        </div>
                                    </Col>
                                    
                                    <Col md={4} className="text-center mb-4">
                                        <div className="advantage-item">
                                            <div className="advantage-icon">
                                                <i className="fas fa-eye text-primary"></i>
                                            </div>
                                            <h5>Visione Strategica</h5>
                                            <p>Approccio olistico che considera obiettivi business e tecnici</p>
                                        </div>
                                    </Col>
                                    
                                    <Col md={4} className="text-center mb-4">
                                        <div className="advantage-item">
                                            <div className="advantage-icon">
                                                <i className="fas fa-rocket text-primary"></i>
                                            </div>
                                            <h5>Risultati Misurabili</h5>
                                            <p>Miglioramenti concreti in performance, sicurezza e qualità</p>
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row className="mb-5">
                    <Col lg={12}>
                        <Card className="service-card highlight-card">
                            <Card.Body>
                                <h2 className="section-title">Digital Transformation</h2>
                                <p className="section-description">
                                    La digitalizzazione non è un prodotto da comprare, ma un percorso da costruire.
                                    Analizziamo come lavora la tua azienda, individuiamo sprechi e colli di bottiglia
                                    e li trasformiamo in processi digitali semplici e automatizzati.
                                </p>

                                <Row>
                                    <Col md={4} className="text-center mb-4">
                                        <div className="advantage-item">
                                            <div className="advantage-icon">
                                                <i className="fas fa-arrows-rotate text-primary"></i>
                                            </div>
                                            <h5>Digitalizzazione dei processi</h5>
                                            <p>Da fogli di calcolo e carta a flussi di lavoro digitali, integrati con il tuo gestionale</p>
                                        </div>
                                    </Col>

                                    <Col md={4} className="text-center mb-4">
                                        <div className="advantage-item">
                                            <div className="advantage-icon">
                                                <i className="fas fa-gears text-primary"></i>
                                            </div>
                                            <h5>Automazione che lavora per te</h5>
                                            <p>Ordini, fatture e magazzino si muovono da soli: eliminiamo le attività ripetitive e gli errori manuali</p>
                                        </div>
                                    </Col>

                                    <Col md={4} className="text-center mb-4">
                                        <div className="advantage-item">
                                            <div className="advantage-icon">
                                                <i className="fas fa-chart-line text-primary"></i>
                                            </div>
                                            <h5>Decisioni guidate dai dati</h5>
                                            <p>Report e dashboard in tempo reale per governare l'azienda con i numeri, non con le sensazioni</p>
                                        </div>
                                    </Col>
                                </Row>

                                <div className="text-center mt-3">
                                    <Link to="/digital-transformation" className="btn-gradient">
                                        <span>Scopri la Digital Transformation</span>
                                    </Link>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row>
                    <Col lg={12}>
                        <Card className="service-card cta-card">
                            <Card.Body className="text-center">
                                <h3>Hai Bisogno di Consulenza Tecnica?</h3>
                                <p className="mb-4">
                                    Contattaci per una consulenza gratuita e scopri come possiamo
                                    ottimizzare i tuoi progetti e migliorare le performance del tuo team.
                                </p>
                                <a href="#contact" className="btn btn-primary btn-lg">
                                    Richiedi Consulenza Gratuita
                                </a>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default ConsulenzaTecnica;